export const AvatarSizes = ['xs', 'sm', 'md', 'lg', 'xl', '2xl'] as const;